import { request } from 'src/api/request';

export const getFilterSets = async ({ queryParams }) => {
  return await request({
    url: `v1/accounts/filter-sets/${queryParams}`,
    method: 'GET',
  });
};

export const getFilterSetById = async ({ queryParams }) => {
  return await request({
    url: `v1/accounts/filter-sets/${queryParams.id}/`,
    method: 'GET',
  });
};

export const createFilterSet = async ({ data }) => {
  return await request({
    url: `v1/accounts/filter-sets/`,
    method: 'POST',
    data,
  });
};

export const updateFilterSet = async ({ filterId, data }) => {
  return await request({
    url: `v1/accounts/filter-sets/${filterId}/`,
    data,
    method: 'PATCH',
  });
};

export const deleteFilterSet = async ({ filterId }) => {
  return await request({
    url: `v1/accounts/filter-sets/${filterId}/`,
    data: {},
    method: 'DELETE',
  });
};
